import React, { Component } from "react";
import Usuario from "../ComponentesGenerales/Usuario";
import {Link} from "react-router-dom";
import {DataGrid} from "@mui/x-data-grid";
import {Stack, Tooltip} from "@mui/material";
import axios from "axios";
import * as environment from "../Global";
import { ExportCSV } from '../ComponentesGenerales/ExportCSV';

const fileName = "Solicitudes Finalizadas";
const columns = [
    { field: 'folio', headerName: 'FOLIO' },
    { field: 'idSucursal', headerName: 'ID SUCURSAL' },
    { field: 'nombreSucursal', headerName: 'NOMBRE SUCURSAL', width: 250},
    { field: 'numVacantes', headerName: '# DE VACANTES' },
    {
        field: 'fechaIngreso', headerName: 'FECHA TENTATIVA DE INGRESO', width: 160, /*renderCell: (cellValues) => {

            var fechaCellValue = cellValues.value.split("/");
            var fechaCellValueCompare = new Date(Date.parse(fechaCellValue[1] + "/" + fechaCellValue[0] + "/" + fechaCellValue[2]));
            var tmpDate = new Date(); // Today
            if ((new Date(addDaysToDate(tmpDate, 0)).getTime() === new Date(addDaysToDate(fechaCellValueCompare, 3)).getTime()) ||
                (new Date(addDaysToDate(tmpDate, 0)).getTime() === new Date(addDaysToDate(fechaCellValueCompare, 2)).getTime()) ||
                (new Date(addDaysToDate(tmpDate, 0)).getTime() === new Date(addDaysToDate(fechaCellValueCompare, 1)).getTime()) ||
                (new Date(addDaysToDate(tmpDate, 0)).getTime() === new Date(addDaysToDate(fechaCellValueCompare, 0)).getTime())) {

                return (
                    <Tooltip title="La fecha tentativa de ingreso está próxima a vencerse, completa esta solicitud a la brevedad.">
                        <i className="fa fa-exclamation-triangle color-warning m-over" aria-hidden="true">
                            <label className="text-label"> {cellValues.row.fechaIngreso}</label>
                        </i>
                    </Tooltip>
                );

            } else if (fechaCellValueCompare.getTime() < new Date(addDaysToDate(tmpDate, 0)).getTime()) {
                //console.log("LA FECHA " + fechaCellValueCompare + " Es MENOR  a la fecha " + tmpDate);
                return (
                    <i className="fa fa-exclamation-triangle color-red m-over" aria-hidden="true"><label
                        className="text-label"> {cellValues.row.fechaIngreso}</label> </i>
                );
            }else {
                return (
                    <i className="fa fa-long-arrow-right color-white    " aria-hidden="true" ><label className="text-label"> {cellValues.row.fechaIngreso}</label> </i>
                );
            }
        }*/
    },
    {
        field: 'detail', headerName: '', renderCell: (cellValues) => {
            return (
                <i className="fa fa-eye m-over"
                   onClick={(event) => {
                       //handleCellClick(event, cellValues);
                       window.location.href = "/solicitudes/detalleFinalizadas/" + cellValues.row.idSolicit + "/" + cellValues.row.idSuc;
                   }} aria-hidden="true" />
            );
        },
    }
];

var digitos = 5;

var ceros_izq = (n, d) => { var e = 10 ** d; return n < e ? ((n + e) + "").slice(1) : n + "" }

var addDaysToDate = (date, days) => {
    var res = new Date(date);
    res.setDate(res.getDate() - days);
    return res.setHours(0,0,0,0);
}

class Finalizadas extends Component{

    state = {
        solicitudesFinalizadas: [],
        status: null,
        descargaExcel: [],
        loader: false,
        buscador: ''
    };

    excelFinalizadas = () => {
        console.log("Entro a excel entrantes");
        axios.post(environment[process.env.REACT_APP_ENVIRONMEN].url_operativo + "/solicits/descargaExcel", {
            "data":
            {
                "idStatus": 4
    
            }
        }).then(response => {
            console.log("Respuesta excel");
            console.log(response.data.data);
            var arrayXLS = [];
            response.data.data.map((respuesta,index)=>{
                var insertXLS = {
                    "Folio de la solicitud": respuesta.idSolicitud,
                    "Estado de la solicitud": "Finalizadas",
                    "ID de la sucursal": respuesta.idSucursal,
                    "Nombre de la sucursal": respuesta.sucursalName,
                    "Dirección de la sucursal": respuesta.addressSuc,
                    "Nombre del responsable": respuesta.respName,
                    "ID Vacante": respuesta.idusuarioVacantes,
                    "Tipo de vacante": respuesta.tipoVacante,
                    "Horario": respuesta.idHorario,
                    "Temporalidad": respuesta.numeroSemanas,
                    "Fecha tentativa de ingreso": respuesta.fechaTentativa,
                    "Nombre del candidato": respuesta.userName,
                    "Estatus del candidato": respuesta.idStatusUser
                }
                arrayXLS.push(insertXLS);
            });
            this.setState({
                descargaExcel: arrayXLS
            });
        });
    }

    componentDidMount() {
        this.getSolicitudesFinalizadas();
    }

    getSolicitudesFinalizadas = () => {
        this.setState({loader: true})
        axios.post(environment[process.env.REACT_APP_ENVIRONMEN].url_operativo + "/solicits/listSolicitFinalizadas", {
            data:
                {
                    "pageNumber": 1,
                    "pageSize": 200

                }
        }).then(response => {
            console.log("data", response.data.data.finalizadas);
            this.setState({
                solicitudesFinalizadas: response.data.data.finalizadas,
                status: 'success',
                loader: false
            });
            this.excelFinalizadas();
        });
    }

    iniciarBuscador = (value) => {
        this.setState({...this.state, buscador: value});
        var finalizadas = this.state.solicitudesFinalizadas;

        if (value === "") {
            this.getSolicitudesFinalizadas();
        } else {
            var filtro = finalizadas.filter((finalizada) => finalizada['sucursalName'].includes(value.toUpperCase()));

            if (filtro.length === 0) {
                filtro = finalizadas.filter((finalizada) => finalizada['id_economico'].includes(value.toUpperCase()));
            }
            if (filtro.length === 0) {
                filtro = finalizadas.filter((finalizada) => finalizada['fechaTentativa'].includes(value));
            }
            if (filtro.length === 0) {
                filtro = finalizadas.filter((finalizada) => ceros_izq(finalizada['idSolicitud'], digitos).includes(value));
            }
            if (filtro.length === 0) {
                filtro = finalizadas.filter((finalizada) => (finalizada['idusuarioVacanates'].toString()).includes(value));
            }
            this.setState({ solicitudesFinalizadas: filtro });
        }
    }

    render(){
        var rows = [];

        const handleChange = e => {
            this.iniciarBuscador(e.target.value);
        };

        if (this.state.solicitudesFinalizadas.length > 0) {

            for (let i = 0; i < this.state.solicitudesFinalizadas.length; i++) {
                var element = {
                    id: i + 1,
                    folio: ceros_izq(this.state.solicitudesFinalizadas[i].idSolicitud, digitos),
                    idSucursal: this.state.solicitudesFinalizadas[i].id_economico,
                    //idSucursal: ceros_izq(this.state.solicitudesFinalizadas[i].idSucursal, digitos),
                    nombreSucursal: this.state.solicitudesFinalizadas[i].sucursalName,
                    numVacantes: this.state.solicitudesFinalizadas[i].idusuarioVacanates,//numero de vacantes
                    fechaIngreso: this.state.solicitudesFinalizadas[i].fechaTentativa,
                    idSuc: this.state.solicitudesFinalizadas[i].idSucursal,
                    idSolicit: this.state.solicitudesFinalizadas[i].idSolicitud
                }
                rows.push(element);
            }
        }

        return (
            <div>
                <div className="row">
                    <div className="col col-lg-6 offset-lg-1">
                        <div className="input-group mb-3">
                            <input type="text"
                                   className="form-control bg-search"
                                   placeholder="&#xf002; Buscar"
                                   onChange = {handleChange}
                            />
                        </div>
                    </div>
                    <div className="col col-lg-1 offset-lg-4">
                        <Usuario />
                    </div>
                </div>
                <div className="FondoBlanco row mt-5">
                    <div className="row mt-5 p-3 mb-5" style={{height: "fit-content"}}>
                        <div className="col-10 btn-group btn-content-ba" role="group">
                            <Link to="/solicitudes"><button type="button" className="btn btn-outline-ba btn-left-ba ">Solicitudes entrantes</button></Link>
                            <Link to="/solicitudes/tomadas"><button type="button" className="btn btn-outline-ba ">Solicitudes tomadas</button></Link>
                            <Link to="/solicitudes/completas"><button type="button" className="btn btn-outline-ba">Solicitudes completas</button></Link>
                            <Link to="/solicitudes/finalizadas"><button type="button" className="btn btn-right-ba btn-outline-ba btn-outline-ba-active">Solicitudes finalizadas
                            </button></Link>
                        </div>
                        <div className="col-2 div-btns-ent mt-5">
                            <button type="button" className="btn-olg-ba" onClick={this.getSolicitudesFinalizadas}>
                                <i className="fa fa-repeat" aria-hidden="true"></i> Actualizar
                            </button>
                            {/*<img className="excel-icon" src={excel_logo} alt="excel icon" />*/}
                            <ExportCSV type={4} buscador={this.state.buscador} csvData={this.state.descargaExcel} fileName={fileName} />
                        </div>
                    </div>
                    <div className="col col-lg-12" style={{display: this.state.loader ? "none" : "block"}}>
                        <div style={{ height: 'auto', width: '100%', padding: '0 55px' }}>
                            <DataGrid
                                autoHeight={true}
                                disableSelectionOnClick
                                rows={rows}
                                columns={columns}
                                pageSize={25}
                                rowsPerPageOptions={[25]}
                                components={{
                                    NoRowsOverlay: () => (
                                        <Stack height="100%" alignItems="center" justifyContent="center">
                                            No se encontraron resultados que coincidan con tu búsqueda
                                        </Stack>
                                    ),
                                    NoResultsOverlay: () => (
                                        <Stack height="100%" alignItems="center" justifyContent="center">
                                            No se encontraron resultados que coincidan con tu búsqueda
                                        </Stack>
                                    )
                                }} />
                        </div>
                    </div>
                    <div className="col col-lg-12" style={{display: this.state.loader ? "block" : "none"}}>
                        <div className="margin-loader">
                            <i className="fa fa-spinner fa-pulse color-green-ba fa-5x fa-fw" />
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div>
                </div>

            </div>
        );
    }
}

export default Finalizadas;
